"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcRentalServices = exports.UcRentalServiceCostAllocators = exports.UcRentalFormServicesTable = exports.RentalServiceCostAllocator = exports.RentalService = void 0;
const RentalService_yaml_component_1 = __importDefault(require("./RentalService.yaml?component"));
exports.RentalService = RentalService_yaml_component_1.default;
const RentalServiceCostAllocator_yaml_component_1 = __importDefault(require("./RentalServiceCostAllocator.yaml?component"));
exports.RentalServiceCostAllocator = RentalServiceCostAllocator_yaml_component_1.default;
const UcRentalFormServicesTable_yaml_component_1 = __importDefault(require("./UcRentalFormServicesTable.yaml?component"));
exports.UcRentalFormServicesTable = UcRentalFormServicesTable_yaml_component_1.default;
const UcRentalServiceCostAllocators_yaml_component_1 = __importDefault(require("./UcRentalServiceCostAllocators.yaml?component"));
exports.UcRentalServiceCostAllocators = UcRentalServiceCostAllocators_yaml_component_1.default;
const UcRentalServices_yaml_component_1 = __importDefault(require("./UcRentalServices.yaml?component"));
exports.UcRentalServices = UcRentalServices_yaml_component_1.default;
